import React from 'react';
import logo from '../assets/malody_logo.png';
import OvalButton from './oval_button.js';

const TitleScreen = ({ goToNextPage }) => {

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}>
            <OvalButton
                bgColor={"hsl(224,43%,74%)"}
                height="200px"
                width="600px"
                imageContent={logo}
                onMouseDown={() => {}}
                onMouseUp={() => setTimeout(goToNextPage, 400)}/>
        </div>
    )
}

export default TitleScreen;
